import format from 'date-fns/format';
import {t} from '../../common/getTranslations';
import {ViewTypeVo} from '../../common/shared/api/karina/vo/enums/ViewTypeVo.enum';
import {TodayNewStaticLandingPageVo} from '../../common/shared/api/nicolas/vo/page/TodayNewStaticLandingPageVo.interface';
import {
  GroupType,
  LayoutType,
  ListViewGroupMeta,
  Maybe,
  MetaInfoType,
  SectionType,
  StaticLandingTodayNewParamInput,
  StaticLandingTodayNewSection,
  StaticLandingType,
  User,
} from '../generated/types';
import {createItem} from './Item';
import {createPromotionBannerItem} from './PromotionBannerItem';
import {createSortOption} from './SortOption';

export function createStaticLandingTodayNewSection(
  userInfo: Maybe<User>,
  {
    sectionId,
    todayNewStaticLandingPageVo: vo,
    input,
    type = LayoutType.Landing,
  }: {
    sectionId?: string;
    todayNewStaticLandingPageVo: TodayNewStaticLandingPageVo;
    input: StaticLandingTodayNewParamInput;
    type?: LayoutType;
  }
): StaticLandingTodayNewSection {
  const {categoryUid, subcategoryUid = vo.selected_subcat_opt?.param} = input;
  const param = {
    categoryUid,
    subcategory: vo.selected_subcat_opt
      ? createSortOption({
          sortOptVo: vo.selected_subcat_opt,
        })
      : undefined,
    screenUid: input.screenUid,
  };
  const isSeriesCardView = vo.view_type === ViewTypeVo.SeriesCardView;

  return {
    id:
      sectionId ||
      `static-landing-${StaticLandingType.TodayNew}-section-${type}-${
        param.categoryUid
      }-${param.subcategory?.param}${
        input.screenUid ? `-${input.screenUid}` : ''
      }`,
    type: SectionType.LandingTodayNew,
    groups:
      vo.list?.map(({day, count, is_today, series_list}) => {
        const [year, month, date] = day.split(' ')[0].split(/-|T/); // ISO 패턴의 T 도 추가
        const title = is_today
          ? t('landing_new_date_today')
          : format(
              new Date(Number(year), Number(month) - 1, Number(date)),
              t('date_formatter_year_less')
            );

        const meta = {
          title,
          count,
        } as ListViewGroupMeta;

        return {
          id: `static-landing-${
            StaticLandingType.TodayNew
          }-${type}-group-${categoryUid}-${subcategoryUid}${
            input.screenUid ? `-${input.screenUid}` : ''
          }-${day}`,
          type: isSeriesCardView ? GroupType.CardView : GroupType.PosterView,
          meta,
          items:
            series_list?.map(item =>
              createItem(userInfo, {
                viewItemVo: {
                  viewItem: item,
                  viewType: isSeriesCardView
                    ? ViewTypeVo.SeriesCardView
                    : ViewTypeVo.SeriesPosterView,
                  sectionType: SectionType.LandingTodayNew,
                  metaInfoType: MetaInfoType.ViewCount,
                },
              })
            ) || [],
        };
      }) || [],
    categoryTabList:
      vo.cat_opt_list?.map(opt => createSortOption({sortOptVo: opt})) || [],
    subcategoryList:
      vo.subcat_opt_list?.map(opt => createSortOption({sortOptVo: opt})) || [],
    totalCount: vo.list?.length ?? 0,
    promotionBanner: vo.section_promotion_banner
      ? createPromotionBannerItem(vo.section_promotion_banner)
      : undefined,
    viewType: vo.view_type,
    param,
  };
}
